export default "__VITE_ASSET__LXDqkgYw__"